import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

export interface HeaderSectionTitleProps {
  className?: string
  compact?: boolean
}

const HEADER_SECTION_TITLE_BASE_STYLES =
  'normal-case text-secondary font-heading font-bold mt-2 mr-0 mb-2 ml-0 flex leading-tight items-center'
const HEADER_SECTION_TITLE_DEFAULT_SIZE = 'text-3xl'
const HEADER_SECTION_TITLE_COMPACT_SIZE = 'text-2xl'

export const HeaderSectionTitle: React.FC<PropsWithChildren<
  HeaderSectionTitleProps
>> = ({ children, className, compact }) => (
  <div
    className={concatStyles([
      HEADER_SECTION_TITLE_BASE_STYLES,
      compact
        ? HEADER_SECTION_TITLE_COMPACT_SIZE
        : HEADER_SECTION_TITLE_DEFAULT_SIZE,
      className,
    ])}
  >
    {children}
  </div>
)

HeaderSectionTitle.displayName = 'Content.HeaderSectionTitle'
